// Copyright 2021-2026 - Hewlett Packard Enterprise Company
import React, { createContext, useState } from 'react';
import { CONTENT_IDS } from '../constants/helpContentIds';

export const HelpContext = createContext();

export default function HelpProvider({ children }) {
  const [contentId, setContentId] = useState(CONTENT_IDS.ANNOUNCEMENTS);
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const [isNotificationCenterOpen, setIsNotificationCenterOpen] =
    useState(false);

  return (
    <HelpContext.Provider
      value={{
        contentIds: CONTENT_IDS, // deprecated, use LearnMoreLink and CONTENT_IDS directly
        contentId,
        setContentId,
        isHelpOpen,
        setIsHelpOpen: (isOpen, { keepNotificationCenter = false } = {}) => {
          if (isOpen && !keepNotificationCenter) {
            setIsNotificationCenterOpen(false);
          }
          setIsHelpOpen(isOpen);
        },
        isNotificationCenterOpen,
        setIsNotificationCenterOpen: isOpen => {
          setIsNotificationCenterOpen(isOpen);
          if (isOpen) {
            setIsHelpOpen(!isOpen);
          }
        },
      }}
    >
      {children}
    </HelpContext.Provider>
  );
}
